import * as React from 'react';
import Helmet, { HelmetProps } from 'react-helmet';
import { getVarioqubCounterScript } from './Varioqub/varioqub';
import { useConfig } from './context';
export interface OwnProps {
	// на сайте redwings стоит другая версия slick-slider
	// поэтому для формы поиска пришлось исключать стили карусели иначе начинались конфликты
	// на движке flyredwings.com/booking/* и на остальных движках карусель включаем
	includeSlickStyles?: boolean;
}

export type Props = HelmetProps & OwnProps;

const Head: React.FC<Props> = ({ includeSlickStyles = true, children, ...props }) => {
	const {
		global: { varioqubId }
	} = useConfig();

	return (
		<Helmet {...props}>
			{varioqubId && (
				<script type="text/javascript" id="varioqub">
					{getVarioqubCounterScript()}
				</script>
			)}

			<link
				rel="stylesheet"
				href="https://cdn.websky.aero/content/frontend/common/libs/normalize/8.0.1/normalize.min.css"
			/>
			{includeSlickStyles && (
				<link
					rel="stylesheet"
					type="text/css"
					href="https://cdn.websky.aero/content/frontend/common/libs/slick-carousel/1.6.0/slick.min.css"
				/>
			)}
			{includeSlickStyles && (
				<link
					rel="stylesheet"
					type="text/css"
					href="https://cdn.websky.aero/content/frontend/common/libs/slick-carousel/1.6.0/slick-theme.min.css"
				/>
			)}
			{children}
		</Helmet>
	);
};

export default Head;
